import { get, post } from './api';
import { signal } from './signal';

export interface Me {
	user: { id: string; displayName: string; isAdmin: boolean } | null;
	plan?: any;
	recoveryCodesLeft?: number;
}

export const me = signal<Me | null>(null);

export async function refreshMe(): Promise<Me> {
	const m = await get<Me>('/api/me');
	me.set(m);
	return m;
}

export async function signOut() {
	await post('/api/auth/logout');
	me.set({ user: null });
}
